<template>
	<div :class="blockClass">

		<div
				class="productlist__loadbtn button button__cancel"
				v-if="elementsTo != 0 && parameters.showMoreBtn && params.currentPage != parameters.pagesCount"
				@click="showMore()"
				:class="[{loading: load.start === true}, btnClass]"
		>
			<button>
				<svg class="icon" v-html="iconHtml"></svg>
				<span v-html="loc.CITRUS_VUE_PAGINATION_SHOW_TOTAL_ELEMENTS"></span>
			</button>
		</div>

		<div class="productlist-bottom" v-if="parameters.showPagination">
			<div
					class="productlist-bottom--pagination"
					v-if="parameters.showPagination && parameters.recordCount > parameters.elementsThisPage"
			>
				<div class="center">
					<div class="pagination">

						<a class="pagination--prev pagination--item"
						   v-if="hasPrev"
						   :class="[{'navigation__link_disabled' : !hasPrev}, disabled ? linkLoadingClass : '']"
						   :title="loc.CITRUS_VUE_PAGINATION_PREV_PAGE"
						   :href="getPageUrl(null, prevPage)"
						   :tabindex="hasPrev ? '0' : '-1'"
						   @click.stop.prevent="changePage(prevPage, $event, !hasPrev)"
						>
							<span>‹</span>
							<div class="pagination--item-text" v-html="loc.CITRUS_VUE_PAGINATION_PREV_PAGE"></div>
						</a>

						<a class="pagination--item"
						   :class="[{active: params.currentPage == page}, disabled ? linkLoadingClass : '']"
						   v-if="hasFirst"
						   :href="getPageUrl(null, 1)"
						   @click.stop.prevent="changePage(1, $event)"
						>1</a>

						<span class="pagination--item pagination--item-more" v-if="hasAfterFirst">...</span>

						<a class="pagination--item"
						   :class="[{active: params.currentPage == page}, disabled ? linkLoadingClass : '']"
						   v-if="parameters.showLinkPages"
						   v-for="page in pages"
						   :href="getPageUrl(null, page)"
						   @click.stop.prevent="changePage(page, $event)"
						   v-html="page"
						></a>

						<span class="pagination--item pagination--item-more" v-if="hasBeforeLast">...</span>

						<a class="pagination--item"
						   :class="[{active: params.currentPage == page},disabled ? linkLoadingClass : '']"
						   v-if="hasLast"
						   :href="getPageUrl(null, parameters.pagesCount)"
						   @click.stop.prevent="changePage(parameters.pagesCount, $event)"
						   v-html="parameters.pagesCount"
						></a>

						<a class="pagination--next pagination--item"
						   :class="[{'navigation__link_disabled' : !hasNext}, disabled ? linkLoadingClass : '']"
						   v-if="parameters.showNextPrevAll || hasNext"
						   :title="loc.CITRUS_VUE_PAGINATION_NEXT_PAGE"
						   :href="getPageUrl(null, nextPage)"
						   :tabindex="hasNext ? '0' : '-1'"
						   @click.stop.prevent="changePage(nextPage, $event, !hasNext)"
						>
							<div class="pagination--item-text" v-if="!parameters.icons" v-html="loc.CITRUS_VUE_PAGINATION_NEXT_PAGE"></div>
							<span>›</span>
						</a>
					</div>
				</div>
			</div>
			<div class="productlist-bottom--count" v-if="params.pageCountResult">
				<Citrus-Vue-Multiselect
						v-model="selected"
						:options="params.pageCountResult"
						:searchable="false"
						:allow-empty="false"
						track-by="name"
						label="title"
						@select="setPageCount"
				></Citrus-Vue-Multiselect>
			</div>
		</div>
	</div>
</template>

<script>
import {Vue} from 'ui.vue';
import SITE_CONFIG from 'citrus.config';
import {Multiselect} from 'citrus.vue.multiselect';

export default {
	store: BX.Citrus.Vuex.store,
	name: 'CitrusPagination',
	component: {Multiselect},
	props: {
		params: Object,
		disabled: {
			type: Boolean,
			default: false
		},
		load: {
			type: Object,
			required: false,
			default: () => {
				return {
					start: false,
					pageNumber: 1,
					isMoreLink: false
				};
			}
		},
		blockClass: {
			type: [String, Boolean, null],
			required: false,
			default: 'citrus-pagination'
		},
		ajaxDisable: {
			type: Boolean,
			default: false
		},
		limit: {
			type: [Boolean, Number],
			default: false
		}
	},
	data: function () {
		return {
			clickCount: 0,
			linkLoadingClass: 'opacity-50 cursor-not-allowed',
			selected: '',
			options: [
				{name: "1", title: "sdvs"}
			]
		};
	},
	created: function () {
		this.selected = this.params.pageCountResult.filter((arItem) => arItem.name == this.params.elementsThisPage);
	},
	computed: {
		iconHtml: function () {
			return '<use x="0" y="0" xlink:href="' + SITE_CONFIG.SVG_PATH + '#icon-Load" ></use>';
		},

		/**
		 * showPagination - показывать кнопки переключения страниц
		 * showMoreBtn - показывать кнопку `Показать ещё`
		 * showNextPrev - показывать кнопки `вперед` и `назад`
		 * showNextPrevAll - показывать кнопки `вперед` и `назад` всегда
		 * pagesCount - всего страниц
		 * pageRange - сколько `кругляшков` страниц показывать справа и слева от текущего
		 * recordCount - всего записей
		 * pageParam - $_GET параметр, отвечающий за номер страницы
		 * url - адрес текущей страницы
		 * ajaxUrl-  адрес ajax обработчика
		 * showFirstLastPage - Отоюражать ссылкы на крайние страницы
		 * icons - Иконки вместо ссылок `вперед` и `назад`
		 * currentElementsMax - количество элементов на странице
		 * showLinkPages - отображать ссылки на страницы
		 * elementsThisPage - количество элементов на текущей странице
		 *
		 * @type {Object} parameters
		 */
		parameters() {
			let defaultUrl = document.location.href,
					result = {
						'pageCountResult': !!(this.params.hasOwnProperty('pageCountResult') && true === this.params.pageCountResult),
						'changeHistory': !!(this.params.hasOwnProperty('changeHistory') && true === this.params.changeHistory),
						'showPagination': !!(this.params.hasOwnProperty('showPagination') && true === this.params.showPagination),
						'showMoreBtn': !!(this.params.hasOwnProperty('showMoreBtn') && true === this.params.showMoreBtn),
						'showNextPrev': !!(this.params.hasOwnProperty('showNextPrev') && true === this.params.showNextPrev),
						'showNextPrevAll': !!(this.params.hasOwnProperty('showNextPrevAll') && true === this.params.showNextPrevAll),
						'pagesCount': this.params.hasOwnProperty('pagesCount') ? this.params['pagesCount'] : 1,
						'pageRange': this.params.hasOwnProperty('pageRange') ? this.params['pageRange'] : 2,
						'recordCount': this.params.hasOwnProperty('recordCount') ? this.params['recordCount'] : '',
						'pageParam': this.params.hasOwnProperty('pageParam') ? this.params['pageParam'] : 'PAGEN_1',
						'url': this.params.hasOwnProperty('url') ? this.params['url'] : defaultUrl,
						'ajaxUrl': this.params.hasOwnProperty('ajaxUrl')
								? this.params['ajaxUrl']
								: (this.params.hasOwnProperty('url') ? this.params['url'] : defaultUrl),
						"showFirstLastPage": this.params.hasOwnProperty('showFirstLastPage') ? this.params.showFirstLastPage : true,
						"icons": !!(this.params.hasOwnProperty('icons') && true === this.params.icons),
						"currentElementsMax": this.params.hasOwnProperty('currentElementsMax') ? this.params['currentElementsMax'] : 1,
						"showLinkPages": this.params.hasOwnProperty('showLinkPages') ? this.params.showLinkPages : false,
						"elementsThisPage": this.params.hasOwnProperty('elementsThisPage') ? this.params.elementsThisPage : this.params.currentElementsMax,
					}
			result['url'] = BX.util.remove_url_param(result['url'], result['pageParam']);
			result['ajaxUrl'] = BX.util.remove_url_param(result['ajaxUrl'], result['pageParam']);
			result['ajaxUrl'] = BX.util.add_url_param(result['ajaxUrl'], {
				'is_ajax': 'Y',
			});

			if (this.params.elementsThisPage < this.params.currentElementsMax) {
				result['recordCount'] = this.params.allElements;
			}

			return result;
		},
		/**
		 * Показывать кнопку `Вперед`
		 *
		 * @returns {boolean}
		 */
		hasNext: function () {
			return !(this.parameters.showNextPrev !== true || this.params.currentPage >= this.parameters.pagesCount);
		},

		/**
		 * Показывать кнопку `Назад`
		 *
		 * @returns {boolean}
		 */
		hasPrev: function () {
			return (this.params.currentPage > 1 && this.parameters['showNextPrev'] === true);
		},

		/**
		 * Отображать ссылку на первую страницу
		 *
		 * @returns {boolean}
		 */
		hasFirst: function () {
			return this.parameters.showFirstLastPage && this.rangeStart !== 1;
		},

		/**
		 * Отображать ссылку на последную страницу
		 *
		 * @returns {boolean}
		 */
		hasLast: function () {
			return this.parameters.showFirstLastPage && this.rangeEnd < this.parameters['pagesCount'];
		},

		/**
		 *
		 * @returns {boolean}
		 */
		hasAfterFirst: function () {
			return this.parameters.pageRange && this.rangeStart > 2;
		},

		/**
		 *
		 * @returns {boolean}
		 */
		hasBeforeLast: function () {
			return this.parameters.pageRange && this.rangeEnd < (this.parameters['pagesCount'] - 1);
		},

		/**
		 * Языковые фразы
		 *
		 * @returns {ReadonlyArray<any>}
		 */
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PAGINATION_");
		},

		/**
		 * Начало подгрузки
		 *
		 * @returns {number}
		 */
		rangeStart: function () {
			let start = this.params.currentPage - this.parameters['pageRange'];
			return (start > 0) ? start : 1;
		},

		/**
		 * Конец подгрузки
		 *
		 * @returns {*}
		 */
		rangeEnd: function () {
			let end = this.params.currentPage + this.parameters['pageRange'];
			return (end < this.parameters['pagesCount']) ? end : this.parameters['pagesCount'];
		},

		/**
		 * Массив страниц
		 *
		 * @returns {Array}
		 */
		pages: function () {
			let pages = [];
			for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
				pages.push(i);
			}
			return pages;
		},

		/**
		 * Следующая страница
		 *
		 * @returns {*}
		 */
		nextPage: function () {
			return this.params.currentPage + 1;
		},

		/**
		 * Предыдущая страница
		 *
		 * @returns {number}
		 */
		prevPage: function () {
			return this.params.currentPage - 1;
		},

		/**
		 * Текст `Всего элементов`
		 *
		 * @returns {*}
		 */
		totalElementsText() {
			let text = this.params.hasOwnProperty('totalElementsText')
					? this.params.totalElementsText
					: this.loc.CITRUS_VUE_PAGINATION_DEFAULT_TOTAL_ELEMENTS
			;

			if (this.parameters['recordCount'] <= 0) {
				return text.replace('#COUNT#', this.params.allElements);
			}

			return text.replace('#COUNT#', this.parameters['recordCount']);
		},

		/**
		 * Номер элемента с которого начинается список
		 *
		 * @returns {string}
		 */
		elementsFrom() {
			return (this.params.currentPage - 1) * this.parameters.currentElementsMax + 1;
		},

		/**
		 * Номер элемента которым заканчивается список
		 *
		 * @returns {string}
		 */
		elementsTo() {
			return this.elementsFrom + this.parameters.elementsThisPage - 1;
		}
	},
	watch: {
		load: {
			handler() {
				this.params.currentPage = parseInt(this.load['pageNumber']);
				let params = {};
				params[this.parameters['pageParam']] = "page-" + this.params.currentPage;
			},
			deep: true
		},
	},
	methods: {
		setPageCount: function (option) {
			this.$store.dispatch('settings/setPageCount', option.name);

			setTimeout(() => {
				window.location.reload();
			}, 100);
		},

		/**
		 * Заголовок страницы при изменении номера страницы
		 * TODO: Используется при клонировании компонента!
		 *
		 * @param pageNumber
		 * @returns {null, string}
		 */
		getPageTitle: function () {
			return null;
		},

		/**
		 * Генерация ссылки окна браузера для пагинации
		 *
		 * @param type
		 * @param pageNumber
		 * @returns {*}
		 */
		getPageUrl: function (type, pageNumber) {
			let data = {};
			if (typeof type === 'string') {
				data[type] = 'Y';
			}
			data[this.parameters['pageParam']] = (typeof pageNumber === 'number')
					? pageNumber
					: this.params.currentPage;

			return BX.util.add_url_param(document.location.href, data);
		},

		/**
		 * Подгрузка элементов через кнопку `Показать ещё`
		 */
		showMore: function ()
		{

			console.log();

			if (this.ajaxDisable || this.load['start']) {
				return false;
			}

			this.clickCount++;

			let pageNumber = this.params.currentPage + 1,
					url = this.getPageUrl('show_more', pageNumber);

			this.$set(this.params, 'currentPage', (this.params.currentPage + 1));

			this.$emit('page-changed', {
				'pageNumber': pageNumber,
				'isMoreLink': true
			});

			if (this.parameters.changeHistory) {
				// window.history.pushState(null, this.getPageTitle(pageNumber), url);
			}

			BX.onCustomEvent('Citrus.PageNavigation.Changed', [pageNumber, true]);

			if (this.clickCount >= parseInt(this.limit)) {
				this.parameters.showMoreBtn = false;
			}
		},

		/**
		 * Изменение страницы через стандартный переключатель
		 * @param pageNumber
		 */
		changePage: function (pageNumber, event, disabled = false) {
			if (this.ajaxDisable) {
				window.location.href = this.getPageUrl(null, pageNumber);
				return;
			}

			if (disabled || this.disabled) {
				return;
			}

			pageNumber = typeof pageNumber !== 'number' ? parseInt(this.params.currentPage) : parseInt(pageNumber);

			this.$set(this.params, 'currentPage', pageNumber);

			let url = this.getPageUrl('change_page', pageNumber);
			if (this.parameters.changeHistory) {
				// window.history.pushState({route: url}, this.getPageTitle(pageNumber), url);
			}

			window.location.href = this.getPageUrl(null, pageNumber);

			this.$emit('page-changed', {'pageNumber': pageNumber});
			BX.onCustomEvent('Citrus.PageNavigation.Changed', [pageNumber, false]);
		}
	}
};
</script>